
import brighthouse from './brighthouse';

const carrier = process.env.REACT_APP_CARRIER_ID;

const config = {
    'bh' : brighthouse,
}
export default config[carrier];